import React, { useContext } from 'react'

import UserContext from '../../context/User/User'

import { ORGANIZATION_PERMISSION_SLUGS } from '@blocktickets/shared-utils'
import { checkPermission } from '../../utilities/helpers'
import AuthService from '../../utilities/services/auth.service'

import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'
import { PaginationProvider } from '../../providers/PaginationProvider/PaginationProvider'
import { OrdersList } from './OrdersList'
import { PageLoadingContainer } from '../PageLoadingContainer'
import { NoPermissionsContainer } from '../NoPermissionsContainer'

export default function SearchOrdersWrapper() {
  const { orgPermissions } = useContext(UserContext)
  const { getPermissions } = AuthService

  const orgPermissionsReady = orgPermissions?.length > 0
  const hasPermission =
    orgPermissionsReady &&
    checkPermission(getPermissions(), ORGANIZATION_PERMISSION_SLUGS.VIEW_ORDERS)

  const organization = AuthService.getOrg()[0]

  if (!orgPermissionsReady) {
    return <PageLoadingContainer style="without-sidebar" />
  }

  if (!hasPermission) {
    return (
      <div className="spacer-sm">
        <NoPermissionsContainer />
      </div>
    )
  }

  return (
    <PaginationProvider>
      <ModalProvider>
        <section
          className="spacer-sm"
          data-testid="search-orders-wrapper-content"
        >
          <header className="section-header-sm">
            <div className="section-heading">
              <h1>Orders</h1>
            </div>
            <p className="section-header-desc">
              Manage, track, and search all customer orders in one place.
            </p>
          </header>
          <OrdersList organization={organization} />
        </section>
      </ModalProvider>
    </PaginationProvider>
  )
}
